import styled from 'styled-components'
import { dimensions, light, spacing } from '~/constants/theme'
import { opacity } from '~/styles'

export const ChatRootWrapper = styled.div`
  width: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0px ${spacing.spacingXL} ${spacing.spacingXL} ${spacing.spacingXL};
  box-sizing: border-box;
  position: relative;
`

export const ChatOverlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: ${spacing.spacingXXL};
  box-sizing: border-box;
  background-color: ${light.dark900}${opacity[4]};
`

export const ChatDragContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${dimensions.borderRadiusSM};
  border: 2px dashed ${light.dark900}${opacity[4]};
`
